// import ModalForm from "./Form";
import PlacementResultTestTableForm from "./PlacementResultTestTableForm";
import {
    DATATABLE_EXPORT,
} from "../../../../../../../Config/ApiUrl";
import {urlGenerator} from "../../../../../../../Helpers/AxiosHelper";

export const PlacementResultTestTableSchema = {
    props: ["isView"],
    components: { PlacementResultTestTableForm },

    data() {
        return {
            DATATABLE_EXPORT,
            isAddEditModalActive: false,
            deleteConfirmationModalActive: false,
            deleteLoader: false,
            selectedUrl: "",
            Endpoint:  "transaction/placement/getDetailResultTest" ,
            tableId: "placement-result-test-table",
            formId: "placement-result-test-table-form",
            rowData: {},
            tableColumns: [
                {
                    title: "Analys Type",
                    type: "text",
                    key: "analys_type"
                },
                {
                    title: "Content Test",
                    type: "text",
                    key: "content_test"
                },

                {
                    title: "Material",
                    type: "text",
                    key: "material",
                },
                {
                    title: "Test",
                    type: "text",
                    key: "material_test",
                },
                {
                    title: "Score",
                    type: "custom-html",
                    key: "score",
                    modifier: (value,row) => {
                        
                        const correct = Number(row.correct) || 0;
                        const total = Number(row.total_mission) || 0;
                        const score = row.score;
                        return `${correct}/${total} (${score}%)`;
                    },
                },
                {
                    title: "Duration",
                    type: "text",
                    key: "duration",
                },
                // {
                //     title: "Result",
                //     type: "text",
                //     key: "result",
                // },
                {
                    title: "Note",
                    type: "text",
                    key: "note",
                },
                {
                    title: "result",
                    type: "custom-html",
                    key: "result",
                    modifier: (value, row) => {
                        if (!value) return '-';
                        
                        const urls = value.split(/\s+/).filter(Boolean);
                        
                        return urls
                            .map(url => {

                                const formattedUrl = /^https?:\/\//i.test(url)
                                    ? url
                                    : `https://${url}`;

                                return `
                                    <div>
                                        <a href="${formattedUrl}" target="_blank" rel="noopener noreferrer">
                                            ${url}
                                        </a>
                                    </div>
                                `;
                            })
                            .join("");
                    }
                },
                
            ],
            ENDPOINT: "transaction/placement/result_test?placement_id=" + this.placementId,
            actionObj: {
                title: this.$t("action"),
                type: "action",
            },
            options: {
                name: "PlacementResultTestTableForm",
                url: "transaction/placement/result_test?placement_id=" + this.placementId,
                showHeader: true,
                enableHighlights: true,
                // enableRowSelect: true,
                enableSaveFilter: true,
                columns: [],
                actions: [
                    {
                        title: this.$t("edit"),
                        icon: "edit",
                        type: "none",
                        component: "placement-result-test-table-form",
                        modalId: "placement-result-test-table-form",
                    },
                    {
                        title: this.$t("delete"),
                        icon: "trash",
                        type: "none",
                        component: "app-confirmation-modal",
                        modalId: "demo-delete",
                    },
                ],
                filters: [
                    
                ],
                showFilter: true,
                showSearch: true,
                showCount: true,
                showClearFilter: true,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: !this.isView,
                orderBy: "desc",
                actionType: "default",
            },
        };
    },
    methods: {
        /**
         * Delete confirmed $emit Form confirmation modal
         */
        onDelete() {
            let url = "transaction/placement/result_test" + "/" + this.rowData.id;
            this.deleteLoader = true;
            this.axiosDelete(url)
                .then((response) => {
                    this.deleteLoader = false;
                    $("#demo-delete").modal("hide");
                    this.onCancelDelete();
                    this.$toastr.s(response.data.message);
                    // this.searchAndSelectFilterOptions();
                })
                .catch(({ err }) => {})
                .finally(() => this.$hub.$emit(`reload-${this.tableId}`));
        },
        onCancelDelete() {
            this.deleteConfirmationModalActive = false;
            this.reSetData();
        },
        reSetData() {
            this.rowData = {};
            this.selectedUrl = "";
        },
    },
};
